import JSZip from 'jszip';
import {
  Button,
  Col,
  Container,
  Form,
  FormControl,
  Image,
  InputGroup,
  Row,
} from 'react-bootstrap';
import './style.css';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { authUser } from '../../services/authService';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { searchService } from '../../services/searchImagesService';
import Swal from 'sweetalert2';
import { useRef } from 'react';
import LogosComponent from '../../components/LogosComponent/LogosComponent';
import { useContext } from 'react';
import AppContext from '../../context/AppContext';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
require('dotenv').config();

const ShowSearchResult = () => {
  const [imagens, setImagens] = useState([]);
  const [company, setCompany] = useState('');
  const inputRef = useRef(null);
  const [disableDownloadAllButton, setDisableDownloadAllButton] = useState({
    deactivated: false,
  });
  const { logo, setLogo } = useContext(AppContext);

  const history = useHistory();

  const downloadImage = (url: string, sku: number) => {
    fetch(url, {
      method: 'GET',
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${sku}.jpg`);
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch(() => {
        toast.error('Houve um erro ao baixar a imagem selecionada.');
      });
  };

  const generateZIP = (event) => {
    event.preventDefault();
    const button = document.getElementsByClassName(
      'download-all-button'
    )[0] as HTMLElement;
    button.innerText = 'Aguarde enquanto as imagens são compactadas';
    button.style.cursor = 'progress';
    toast.info('Por favor aguarde enquanto compactamos as imagens.');
    const zip = new JSZip();
    let count = 0;
    const zipFilename = 'rojemac-imagens.zip';
    imagens.forEach(({ url, numero }, i) => {
      const filename = `${numero}-${i + 1}.jpg`;
      JSZipUtils.getBinaryContent(url, (_err, data) => {
        zip.file(filename, data, { binary: true });
        count++;
        if (count === imagens.length) {
          zip.generateAsync({ type: 'blob' }).then((content) => {
            saveAs(content, zipFilename);
          });
        }
      });
    });
    button.innerText = 'Baixar imagens encontradas';
    button.style.cursor = 'pointer';
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setImagens([]);
    let finalArray: string[] = [];
    const valor = inputRef.current.value;
    if (valor.trim().length < 3) {
      return toast.error('A pesquisa deve incluir ao menos um SKU.');
    }

    if (!company.length) {
      return toast.error(
        'Selecione a empresa (Rojemac ou Lyor) antes de pesquisar.'
      );
    }

    if (valor.includes(',')) {
      finalArray = valor
        .split(',')
        .map((el) => el.trim())
        .filter((el) => parseInt(el) && el.length >= 3);
    } else {
      finalArray = valor
        .split(' ')
        .filter((el) => el.trim() !== '')
        .map((el) => el.trim())
        .filter((el) => parseInt(el) && el.length >= 3);
    }

    if (finalArray.length > 250) {
      return toast.error('O limite por pesquisa é de até 250 produtos.');
    }

    const products = await searchService(finalArray, company);
    const { references, notFoundImages } = products;
    references.length &&
      toast.success(`Foram encontradas ${references.length} imagens`);
    setImagens(references);
    if (references.length) disableDownloadAllButton.deactivated = false;
    if (notFoundImages && notFoundImages.length) {
      const notFound = notFoundImages.join(', ');
      Swal.fire({
        title: 'SKUs não localizados',
        text: `Os SKUs ${notFound} não foram localizados.`,
      });
    }
  };

  const handleVideosRedirect = () => {
    switch (logo) {
      case 'rojemac':
        window.open(process.env.REACT_APP_ROJEMAC_VIDEOS_URL);
        break;
      case 'lyor':
        window.open(process.env.REACT_APP_LYOR_VIDEOS_URL);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    (async () => {
      await authUser();
    })().catch(() => {
      history.push('/login');
    });
    inputRef.current.focus();
  }, []);

  useEffect(() => {
    inputRef.current.focus();
  }, [company]);

  useEffect(() => () => setLogo(''), []);

  return (
    <div>
      <Container>
        <div className='search-container'>
          <InputGroup className='mb-3'>
            <FormControl
              ref={inputRef}
              onKeyPress={(e) => e.key === 'Enter' && handleSubmit(e)}
              placeholder='Digite os SKUs separados por vírgula ou espaço'
              aria-label='Digite os SKUs separados por vírgula ou espaço'
              aria-describedby='basic-addon2'
            />
            <Button
              onClick={handleSubmit}
              className='search-button'
              variant='primary'
              id='button-addon2'
            >
              Pesquisar
            </Button>
          </InputGroup>
          <div className='button-container'>
            {imagens.length ? (
              <Button
                disabled={disableDownloadAllButton.deactivated}
                className='download-all-button'
                onClick={generateZIP}
              >
                Baixar imagens encontradas
              </Button>
            ) : null}
            <Form>
              <div key='inline-radio' className='mb-3 inline-radio'>
                <Form.Check
                  inline
                  onChange={() => {
                    setLogo('rojemac');
                    setCompany('rojemac');
                  }}
                  label='Rojemac'
                  name='group1'
                  type='radio'
                  id='inline-radio-1'
                />
                <Form.Check
                  onChange={() => {
                    setLogo('lyor');
                    setCompany('lyor');
                  }}
                  inline
                  label='Lyor'
                  name='group1'
                  type='radio'
                  id='inline-radio-2'
                />
                {!!logo.length && (
                  <Button
                    onClick={() => handleVideosRedirect()}
                    id='videos-button'
                    variant={logo === 'rojemac' ? 'primary' : 'danger'}
                  >
                    Vídeos
                  </Button>
                )}
              </div>
            </Form>
          </div>
        </div>
        <Row>
          {imagens && imagens.length
            ? imagens.map((img) => {
                return (
                  <Col
                    className='image-col shadow-lg'
                    key={img.url}
                    xs={6}
                    md={3}
                  >
                    <LazyLoadImage
                      className='zoom'
                      src={img.url} // use normal <img> attributes as props
                      width='260px'
                      effect='blur'
                    />
                    {/* <Image
                      className='zoom'
                      src={`${img.url}`}
                      thumbnail
                      width='260px'
                    /> */}
                    <figcaption
                      onClick={() => downloadImage(img.url, img.numero)}
                      className='fig-image'
                    >
                      Download SKU: {img.numero}
                    </figcaption>
                  </Col>
                );
              })
            : null}
        </Row>
      </Container>
      <LogosComponent />
    </div>
  );
};
export default ShowSearchResult;
